import axios from "@/plugins/http.service.js";
export default {
    getData(data) {
        return axios.post("api/web/sub-category/get-admin-sub-categories", data)
    },
    getStat() {
        return axios.post("api/web/sub-category/get-admin-sub-categories-stat")
    }, getCat() {
        return axios.post("api/web/category/get-cat")
    }, batchAddRows(records) {
        return axios.post("api/web/sub-category/batch-add-sub-categories", { records: records })
    },
}

